import { Avatar, Box, Stack } from "@mui/material";
import styles from "../../../styles/pages/analyticseditor.module.scss";
import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import styles2 from "../../../styles/pages/home.module.scss";
import stylesAnalytics from "../../../styles/pages/analytics.module.scss";
import "react-perfect-scrollbar/dist/css/styles.css";
import assest from "../../../json/assest";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { useInfiniteQuery, useQuery } from "react-query";
import {
  customTopAcquisitorsList,
  topAcquisitorsList,
} from "../../../api/functions/user.api";
import { concatHostAndImagePath } from "../../../lib/functions/utils.lib";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import PartnerCard from "../../../components/PartnerCard/PartnerCard";
import TopAccusitorPartnerCard from "../../../components/TopAcquisitorsCards/TopAccusitorPartnerCard";
import TopAcqusitiorBuyerCard from "../../../components/TopAcquisitorsCards/TopAcqusitiorBuyerCard";
import InfiniteScroll from "react-infinite-scroll-component";

const TopAcquisitors = ({
  filterDate,
  handleToggleTopApproved,
  openTopApproved,
  // handleOpenExpensesModal,
  isApiCalledSuccessfully,
  // selectedRollID,
  sendDataToParent,
}) => {
  const [buttonText, setButtonText] = React.useState("Approved");
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const showListHandler = () => setIsDropdownOpen(!isDropdownOpen);
  const [showAllData, setShowAllData] = useState(false);
  // const [topAcquisitor, setTopAcquisitor] = useState([]);
  const [leftData, setLeftData] = useState([]);
  const [rightData, setRightData] = useState([]);
  const [pageParam, setPageParam] = useState(1);
  const [divexpend, setDivexpend] = useState(false);

  const handleMenuItemClick = () => {
    if (buttonText === "Approved") {
      // handleToggleTopApproved(true);
      setButtonText("All");
      setShowAllData(true);
      setDivexpend(true);

      // loadMore()
      sendDataToParent(true);

      showListHandler();
    } else {
      // handleToggleTopApproved(false);
      setButtonText("Approved");
      showListHandler();
      setShowAllData(false);
      sendDataToParent(false);
    }
  };
  const imageBaseUrl = "https://vsclips.s3.us-east-2.amazonaws.com";
  /*   const { data, isLoading, refetch } = useQuery(
    ["customTopAcquisitorsList", filterDate, pageParam],
    () => customTopAcquisitorsList(filterDate, pageParam),
    {
      onSuccess: (data) => {
        setTopAcquisitor((prevData) => [...prevData, ...data.data]);
        if (pageParam < data?.last_page) {
          setPageParam(pageParam + 1);
        }
      },
    }
  ); */

  const { data, fetchNextPage, hasNextPage, refetch, isLoading, isRefetching } =
    useInfiniteQuery({
      queryKey: [
        "customTopAcquisitorsList",
        filterDate,
        // search, status1, date
      ],
      queryFn: ({ pageParam = 1 }) => {
        return customTopAcquisitorsList(filterDate, pageParam);
      },
      keepPreviousData: true,
      enabled: true,

      getNextPageParam: (lastPage, allPages) => {
        if (
          allPages[allPages.length - 1 || 0].current_page <
          allPages[0]?.last_page
        ) {
          return allPages[allPages.length - 1 || 0].current_page + 1;
        } else {
          return undefined;
        }
      },
    });

  const topAcquisitor = useMemo(() => {
    var dat = { data: [] };
    data?.pages?.forEach((item) => {
      dat = { ...item, data: [...dat.data, ...item?.data] };
    });
    return dat;
  }, [data]);

  useEffect(() => {
    // isApiCalledSuccessfully(isLoading);
    if (topAcquisitor) {
      const totalItems = topAcquisitor.data ? topAcquisitor?.data?.length : 0;
      const leftItems = showAllData
        ? Math.ceil(totalItems / 2)
        : Math.min(totalItems);
      console.log("leftItems", leftItems);
      console.log("totalItems", totalItems, leftItems);
      setLeftData(topAcquisitor?.data?.slice(0, leftItems));
      setRightData(showAllData ? topAcquisitor?.data?.slice(leftItems) : []);
    }
  }, [isLoading, showAllData, topAcquisitor]);

  // useEffect(() => isApiCalledSuccessfully(isLoading), [isLoading]);
  // const selectedAquisitorHandler = (roll_id) => {
  //   selectedRollID.current = roll_id;
  //   handleOpenExpensesModal();
  // };

  useEffect(() => {
    function handleClickOutside(event) {
      // console.warn("Clicked outside");
      if (isDropdownOpen && !event.target.closest(`.${styles.year_drop}`)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <>
      <Box
        className={`${styles.analyticBoxFive} ${styles.commonSmallBoxWrapperAnalytic} ${stylesAnalytics.topAquisitor}`}
      >
        <ApiLoader loading={isLoading} />

        {!isLoading && (
          <Box className="commonSmallBox commonSmallBoxAnalytics analyticBoxFive">
            <Box className={styles2.commonSmallBox}>
              <Box className={styles2.infoTable}>
                <Box
                  className={`${styles2.infoTable_head} ${styles.infoTable_head_analytic} ${styles.infoTableHeadFive}`}
                >
                  <Link href="">
                    <Box className={styles2.tble_hdng}>TOP Acquisitors</Box>
                    <Box
                      className={`${styles2.tble_hdng} ${stylesAnalytics.tbleHdngAnatytics}`}
                    >
                      <Button
                        // onClick={handleToggleTopApproved}
                        onClick={showListHandler}
                        className={`${
                          isDropdownOpen ? styles2.active_drop : null
                        }`}
                      >
                        {buttonText}
                        {isDropdownOpen ? (
                          <img
                            src={assest.upArrow}
                            width={7}
                            height={10}
                            alt=""
                          />
                        ) : (
                          <img
                            src={assest.downArrow}
                            width={7}
                            height={10}
                            alt=""
                          />
                        )}
                      </Button>
                      {isDropdownOpen && (
                        <Box className={styles2.year_drop}>
                          <ul onClick={handleMenuItemClick}>
                            <li>
                              {buttonText === "Approved" ? "All" : "Approved"}
                            </li>
                          </ul>
                        </Box>
                      )}
                    </Box>
                  </Link>
                </Box>

                <Stack direction={"row"} justifyContent={"center"}>
                  <Box className={styles.topacquisitorAnalytic}>
                    {topAcquisitor && topAcquisitor?.data?.length > 0 ? (
                      <>
                        <InfiniteScroll
                          dataLength={topAcquisitor?.data?.length}
                          next={fetchNextPage}
                          height={`calc(100vh - 680px)`}
                          hasMore={hasNextPage}
                          loader={<h4>Loading...</h4>}
                          className={styles.acquitorScroll}
                        >
                          <Box className={styles.acquitorLeft}>
                            {leftData?.map((item, index) => {
                              if (item?.role_id === 3) {
                                return (
                                  <>
                                    <TopAccusitorPartnerCard
                                      key={index}
                                      user={item}
                                      image={item?.avatar}
                                      accountSubmission={true}
                                      classProps={"true"}
                                      cardProp={"partner"}
                                      user_id={item?.id}
                                      index={index}
                                      buttonText={buttonText}
                                      topAcqusitiorRefetch={refetch}
                                    />
                                  </>
                                );
                              } else if (item?.role_id === 2) {
                                return (
                                  <TopAccusitorPartnerCard
                                    key={index}
                                    user={item}
                                    image={item?.avatar}
                                    cardName={item?.account_name}
                                    cardLink={item?.submission_link}
                                    cardTime={item?.created_at}
                                    cardTextspan1={"Fee Per Submission:"}
                                    cardTextspan2={"Full Name:"}
                                    cardTextspan3={"email address:"}
                                    cardtext1={
                                      item?.flat_rate ? item?.flat_rate : "0"
                                    }
                                    cardtext2={`${item?.name} ${item?.last_name}`}
                                    cardtext3={item?.email}
                                    buttonName={
                                      `${item?.status}` == 1
                                        ? "ACTIVE"
                                        : "INACTIVE"
                                    }
                                    accountSubmission={true}
                                    classProps={"true"}
                                    cardProp={"member"}
                                    user_id={item?.id}
                                    cardVideoCount={
                                      item?.videos_count
                                        ? item?.videos_count
                                        : "-"
                                    }
                                    cardVideoApprovedCount={
                                      item?.videosApproved
                                        ? item?.videosApproved
                                        : "-"
                                    }
                                    cardVideoRejectedCount={
                                      item?.videosRejected
                                        ? item?.videosRejected
                                        : "-"
                                    }
                                    cardVideoDuplicateCount={
                                      item?.videos_duplicate
                                        ? item?.videos_duplicate
                                        : "-"
                                    }
                                    index={index}
                                    buttonText={buttonText}
                                    topAcqusitiorRefetch={refetch}
                                  />
                                );
                              } else {
                                return (
                                  <TopAcqusitiorBuyerCard
                                    key={index}
                                    image={item?.avatar}
                                    cardName={`${item?.name} ${item?.last_name}`}
                                    cardLink={item?.submission_link}
                                    cardTime={item?.joined_at}
                                    cardTextspan1={
                                      item?.payment_type === 2
                                        ? "Commission Per Purchase: "
                                        : "Salary: "
                                    }
                                    cardTextspan2={"Email address:"}
                                    cardtext1={
                                      item?.payment_type === 1 &&
                                      item.flat_rate !== null &&
                                      item.flat_rate !== "0"
                                        ? item?.flat_rate
                                        : item?.payment_type === 2 &&
                                          item.rate_per_video !== null &&
                                          item.rate_per_video !== "0"
                                        ? item?.rate_per_video
                                        : 0
                                    }
                                    cardtext2={item?.email}
                                    buttonName={
                                      item?.status ? "ACTIVE" : "INACTIVE"
                                    }
                                    accountSubmission={true}
                                    cardTextspan3={""}
                                    cardtext3={""}
                                    classProps={"true"}
                                    cardProp={"buyerList"}
                                    user_id={item?.id}
                                    cardVideoCount={0}
                                    cardVideoApprovedCount={0}
                                    cardVideoRejectedCount={0}
                                    cardVideoDuplicateCount={0}
                                    totalData={item}
                                    index={index}
                                    buttonText={buttonText}
                                    topAcqusitiorRefetch={refetch}
                                  />
                                );
                              }
                            })}
                          </Box>

                          <Box className={styles.acquitorRight}>
                            {showAllData && (
                              <>
                                {rightData?.map((item, index) => {
                                  if (item?.role_id === 3) {
                                    return (
                                      <>
                                        <TopAccusitorPartnerCard
                                          key={index}
                                          user={item}
                                          image={item?.avatar}
                                          cardName={item?.account_name}
                                          cardLink={item?.submission_link}
                                          cardTime={item?.created_at}
                                          cardTextspan1={"Fee Per Submission:"}
                                          cardTextspan2={"Full Name:"}
                                          cardTextspan3={"email address:"}
                                          cardtext1={
                                            item?.flat_rate
                                              ? item?.flat_rate
                                              : "0"
                                          }
                                          cardtext2={`${item?.name} ${item?.last_name}`}
                                          cardtext3={item?.email}
                                          buttonName={
                                            `${item?.status}` == 1
                                              ? "ACTIVE"
                                              : "INACTIVE"
                                          }
                                          accountSubmission={true}
                                          classProps={"true"}
                                          cardProp={"partner"}
                                          user_id={item?.id}
                                          cardVideoCount={
                                            item?.videos_count
                                              ? item?.videos_count
                                              : "-"
                                          }
                                          cardVideoApprovedCount={
                                            item?.videosApproved
                                              ? item?.videosApproved
                                              : "-"
                                          }
                                          cardVideoRejectedCount={
                                            item?.videosRejected
                                              ? item?.videosRejected
                                              : "-"
                                          }
                                          cardVideoDuplicateCount={
                                            item?.videos_duplicate
                                              ? item?.videos_duplicate
                                              : "-"
                                          }
                                          index={index}
                                          buttonText={buttonText}
                                          showAllData={showAllData}
                                          leftData={leftData}
                                          topAcqusitiorRefetch={refetch}
                                        />
                                      </>
                                    );
                                  } else if (item?.role_id === 2) {
                                    return (
                                      <TopAccusitorPartnerCard
                                        key={index}
                                        user={item}
                                        image={item?.avatar}
                                        cardName={item?.account_name}
                                        cardLink={item?.submission_link}
                                        cardTime={item?.created_at}
                                        cardTextspan1={"Fee Per Submission:"}
                                        cardTextspan2={"Full Name:"}
                                        cardTextspan3={"email address:"}
                                        cardtext1={
                                          item?.flat_rate
                                            ? item?.flat_rate
                                            : "0"
                                        }
                                        cardtext2={`${item?.name} ${item?.last_name}`}
                                        cardtext3={item?.email}
                                        buttonName={
                                          `${item?.status}` == 1
                                            ? "ACTIVE"
                                            : "INACTIVE"
                                        }
                                        accountSubmission={true}
                                        classProps={"true"}
                                        cardProp={"member"}
                                        user_id={item?.id}
                                        cardVideoCount={
                                          item?.videos_count
                                            ? item?.videos_count
                                            : "-"
                                        }
                                        cardVideoApprovedCount={
                                          item?.videosApproved
                                            ? item?.videosApproved
                                            : "-"
                                        }
                                        cardVideoRejectedCount={
                                          item?.videosRejected
                                            ? item?.videosRejected
                                            : "-"
                                        }
                                        cardVideoDuplicateCount={
                                          item?.videos_duplicate
                                            ? item?.videos_duplicate
                                            : "-"
                                        }
                                        index={index}
                                        buttonText={buttonText}
                                        showAllData={showAllData}
                                        leftData={leftData}
                                        topAcqusitiorRefetch={refetch}
                                      />
                                    );
                                  } else if (item?.role_id === 2) {
                                    return (
                                      <TopAcqusitiorBuyerCard
                                        key={index}
                                        image={item?.avatar}
                                        cardName={`${item?.name} ${item?.last_name}`}
                                        cardLink={item?.submission_link}
                                        cardTime={item?.joined_at}
                                        cardTextspan1={
                                          item?.payment_type === 2
                                            ? "Commission Per Purchase: "
                                            : "Salary: "
                                        }
                                        cardTextspan2={"Email address:"}
                                        cardtext1={
                                          item?.payment_type === 1 &&
                                          item.flat_rate !== null &&
                                          item.flat_rate !== "0"
                                            ? item?.flat_rate
                                            : item?.payment_type === 2 &&
                                              item.rate_per_video !== null &&
                                              item.rate_per_video !== "0"
                                            ? item?.rate_per_video
                                            : 0
                                        }
                                        cardtext2={item?.email}
                                        buttonName={
                                          item?.status ? "ACTIVE" : "INACTIVE"
                                        }
                                        accountSubmission={true}
                                        cardTextspan3={""}
                                        cardtext3={""}
                                        classProps={"true"}
                                        cardProp={"buyerList"}
                                        user_id={item?.id}
                                        cardVideoCount={0}
                                        cardVideoApprovedCount={0}
                                        cardVideoRejectedCount={0}
                                        cardVideoDuplicateCount={0}
                                        totalData={item}
                                        index={index}
                                        buttonText={buttonText}
                                        showAllData={showAllData}
                                        leftData={leftData}
                                        topAcqusitiorRefetch={refetch}
                                      />
                                    );
                                  } else {
                                    ("");
                                  }
                                })}
                              </>
                            )}
                          </Box>
                        </InfiniteScroll>
                      </>
                    ) : (
                      /*  topAcquisitor.map((item, index) => {
                        return (
                          <Box
                            key={index + 1}
                            className={styles.topacquisitorAnalyticBox}
                            // onClick={()=>selectedAquisitorHandler(item?.role_id)}
                          >
                            <Box className={styles.acquisitorAnalyticBoxNo}>
                              {index + 1}.
                            </Box>

                            <Box
                              className={styles.acquisitorAnalyticBoxdetails}
                            >
                              <Box
                                className={
                                  styles.acquisitorAnalyticBoxdetailsImg
                                }
                              >
                                {item?.avatar !== null ? (
                                  <Avatar
                                    src={concatHostAndImagePath(item?.avatar)}
                                    width={52}
                                    height={52}
                                    alt=""
                                  />
                                ) : (
                                  <Avatar
                                    src="/assets/images/memberProfileImg.png"
                                    width={52}
                                    height={52}
                                    alt=""
                                  />
                                )}
                              </Box>

                              <Box
                                className={
                                  styles.acquisitorAnalyticBoxdetailsTxt
                                }
                              >
                                {item.name && (
                                  <h4>
                                    {item.name}{" "}
                                    {item?.videos_count && (
                                      <span>
                                        {buttonText === "Approved"
                                          ? item?.videos_approved_count
                                          : item?.videos_count}
                                      </span>
                                    )}
                                  </h4>
                                )}
                                {item?.role?.display_name && (
                                  <p>{item?.role?.display_name}</p>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        );
                      }) */
                      <p>No users have been added yet.</p>
                    )}
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default memo(TopAcquisitors);
